import { CartItem as EtiCartItem, Icon } from '@eti/components';
import { price as priceUtil, date as dateFormatter } from '@eti/utils';
import { css, etiColors } from '@eti/styles';
import { useDateFormat, useTranslation } from '@eti/providers';
import { AddOnOrder } from '@eti/types';
import ReceiptProducts from './price-specification/ReceiptProducts';

const orderDateStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.625rem;
`;

const creationDateStyles = css`
  font-size: 0.875rem;
`;

const postBookingOrderWrapperStyles = css`
  color: #333;
  padding-top: 16px;

  &:last-child {
    margin-bottom: 20px;
  }
`;

const cartItemStyles = css`
  border-color: #aaa;
`;

const productIconStyles = css`
  height: 1rem;
  width: 1rem;
`;

const productItemStyles = css`
  border-color: ${etiColors.grayScale[8]};
  margin: 0;

  &:last-child {
    border-bottom: 1px dotted ${etiColors.grayScale[8]};
  }
`;

const ProductItem = (props) => (
  <div data-testid="orderPage-postBooking-product">
    <EtiCartItem className={productItemStyles} {...props} />
  </div>
);

const PostBookingOrder = ({ addOnOrder }) => {
  const { t } = useTranslation();
  const { date } = useDateFormat();
  const { creationDate, price, extraProducts } = addOnOrder;

  return (
    <div className={postBookingOrderWrapperStyles} data-testid="orderPage-postBooking-order">
      <p className={orderDateStyles}>{t('Receipt.ReceiptDetails.Label.OrderDate')}</p>
      <p className={creationDateStyles}>{dateFormatter.format(creationDate, date)}</p>
      <EtiCartItem
        className={cartItemStyles}
        icon={<Icon color="#707070" id="cart-addon" size="1rem" />}
        price={priceUtil.formatPrice(price.price.value)}
        title={t('Order.Receipt.PostbookingPurchase.Label')}
      />
      <ReceiptProducts
        component={ProductItem}
        iconStyles={productIconStyles}
        products={extraProducts.map((product) => ({
          ...product,
          price: product.price.price.value,
        }))}
        viewMode="-postbooking-purchase"
      />
    </div>
  );
};

PostBookingOrder.propTypes = {
  addOnOrder: AddOnOrder,
};

export default PostBookingOrder;
